"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionSelectedDefault = exports.getOptionLabelDefault = void 0;
exports.getOptionLabelDefault = function (option) {
    return option.title || '';
};
exports.getOptionSelectedDefault = function (option, value) {
    return option.id === value.id;
};
